export const qs = (s, o = document) => o.querySelector(s);
export const qsa = (s, o = document) => [...o.querySelectorAll(s)];

export const renderIndex = (index, length = 3) => {
  return index.toString().padStart(length, '0');
};
